import { useAirlinesFilters } from '../AirlinesFilters/hooks/useAirlinesFilters'
import { useAirportsFilters } from '../AirportsFilters/hooks/useAirportsFilters'
import { useTimeDispatch } from '../TimeFilters/Hooks/UseTimeDispatch'
import { useDebouncedListingsFilterCall } from '@mfs/client/listings-client/components/Filters/useDebouncedListingsFilterCall/useDebouncedListingsFilterCall'
import { useSelector } from 'react-redux'
import { useStopsFilters } from '../StopsFilters/hooks/useStopsFilters'
import { useAttributeFilters } from '../AttributesFilters/hooks/useAttributeFilters'

export function useResetHandlers() {
  const { debouncedListingsFilterCall } = useDebouncedListingsFilterCall()

  const activeTabId = useSelector((state) => state.activeTabId)

  const { resetClick: resetClickAirlines } = useAirlinesFilters({
    changeHandler: debouncedListingsFilterCall,
  })

  const { resetHandler: resetClickTime } = useTimeDispatch({
    activeTabId,
    changeHandler: debouncedListingsFilterCall,
  })

  const { onSelectNoneClick: resetClickAirports } = useAirportsFilters({
    changeHandler: debouncedListingsFilterCall,
  })

  const { resetClick: resetClickStops } = useStopsFilters({
    changeHandler: debouncedListingsFilterCall,
  })

  const { resetClick: resetClicksAttributes } = useAttributeFilters({
    changeHandler: debouncedListingsFilterCall,
  })

  return {
    resetClickAirlines,
    resetClickTime,
    resetClickAirports,
    resetClickStops,
    resetClicksAttributes,
  }
}
